import { render } from "./CreatePinView.vue?vue&type=template&id=62d64915"
import script from "./CreatePinView.vue?vue&type=script&lang=js"
export * from "./CreatePinView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__